import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class FalconersTower1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FALCONERS_TOWER1;
}

export default FalconersTower1PoiTileEntity;
